import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { useLocale } from "context/locale"
import Label from "components/Label"
import Button from "components/Button"
// import UodIcon from "icons/udo.svg"
import ArrowDownIcon from "icons/arrow_down.svg"
import ArrowRightIcon from "icons/arrow_right.svg"
import StyledHelpPlanet from "./styles"

const HelpPlanet = () => {
  const { t } = useLocale()
  const data = useStaticQuery(
    graphql`
      query {
        image: file(
          relativePath: { eq: "refresh/1920_946_JAK_MOZEMY_POMOC_PLANECIE.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        image_mobile: file(
          relativePath: { eq: "refresh/1920_946_JAK_MOZEMY_POMOC_PLANECIE.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  const source = [
    data.image_mobile.childImageSharp.fluid,
    {
      ...data.image.childImageSharp.fluid,
      media: `(min-width: 601px)`,
    },
  ]

  return (
    <StyledHelpPlanet>
      <BackgroundImage
        fluid={source}
        className="box-intro"
        backgroundColor={`#fff`}
        style={{ backgroundPosition: "top center" }}
      >
        <button className="scroll-arrow" type="button" aria-label="scroll">
          <ArrowDownIcon />
        </button>
        <header className="box-intro__header">
          <Label text="#planet" lg />
          <h2 className="title h1">
            {t("Things you can do to help the planet!")}
          </h2>
        </header>
      </BackgroundImage>
      <div className="box-about">
        <div className="main-container">
          <div className="box-about__inner">
            <div className="box-about__description">
              <div className="box-image">
                <img
                  src={
                    require("images/refresh/4FXUBRANIA_DO_ODDANIA.png").default
                  }
                  alt=""
                />
              </div>
              <div className="box-text">
                <p>
                  {t(
                    "Help us save the planet and join our circular program. Bring the clothes you don’t use to one of the 4F stores and close the loop. Thanks to you, instead of ending up in a landfill, they will get a second life and bring joy to their new owner, and you’ll not only help the planet but also support the 4F POMAGA Foundation."
                  )}
                </p>
              </div>
            </div>
            <div className="box-about__grid">
              <div className="grid-item">
                <div className="box-image">
                  <svg
                    id="Group_42"
                    data-name="Group 42"
                    xmlns="http://www.w3.org/2000/svg"
                    width="62.002"
                    height="88.576"
                    viewBox="0 0 62.002 88.576"
                  >
                    <path
                      id="Path_106"
                      data-name="Path 106"
                      d="M408-199.679v84.146a2.215,2.215,0,0,1-2.215,2.215H348.218A2.215,2.215,0,0,1,346-115.533v-21.745a2.663,2.663,0,0,1,2.662-2.663h26.124v-50.93A2.215,2.215,0,0,1,377-193.087a2.213,2.213,0,0,1,2.214,2.215v50.93h17.716a2.215,2.215,0,0,1,2.214,2.215,2.212,2.212,0,0,1-.648,1.565,2.212,2.212,0,0,1-1.565.648h-46.5v17.767h50.931a2.215,2.215,0,0,0,2.213-2.215V-195.25a2.214,2.214,0,0,0-2.213-2.214H352.645a2.213,2.213,0,0,0-2.214,2.214v48.618a2.252,2.252,0,0,1-2.26,2.262,2.206,2.206,0,0,1-1.52-.648,2.212,2.212,0,0,1-.648-1.565v-53.095a2.216,2.216,0,0,1,2.215-2.215H405.79A2.216,2.216,0,0,1,408-199.679"
                      transform="translate(-346.003 201.894)"
                    />
                    <path
                      id="Path_107"
                      data-name="Path 107"
                      d="M368.287-154.384a2.213,2.213,0,0,1-2.214,2.214,2.213,2.213,0,0,1-2.215-2.214,2.213,2.213,0,0,1,2.215-2.214,2.213,2.213,0,0,1,2.214,2.214"
                      transform="translate(-335.072 229.624)"
                    />
                    <path
                      id="Path_108"
                      data-name="Path 108"
                      d="M362.794-180.482a2.215,2.215,0,0,1-2.215,2.215,2.215,2.215,0,0,1-2.214-2.215,2.213,2.213,0,0,1,2.214-2.214,2.213,2.213,0,0,1,2.215,2.214"
                      transform="translate(-338.435 213.648)"
                    />
                    <path
                      id="Path_109"
                      data-name="Path 109"
                      d="M373.782-180.482a2.215,2.215,0,0,1-2.215,2.215,2.214,2.214,0,0,1-2.214-2.215,2.213,2.213,0,0,1,2.214-2.214,2.213,2.213,0,0,1,2.215,2.214"
                      transform="translate(-331.708 213.648)"
                    />
                  </svg>
                </div>
                <div className="box-text">
                  <p className="h4 title">{t("get rid of")}</p>
                  <p>{t("unwanted clothes from your wardrobe")}</p>
                  <p>{t("from your wardrobe")}</p>
                </div>
              </div>
              <div className="grid-item-divider">
                <ArrowRightIcon />
              </div>
              <div className="grid-item">
                <div className="box-image">
                  <svg
                    id="Group_43"
                    data-name="Group 43"
                    xmlns="http://www.w3.org/2000/svg"
                    width="62.064"
                    height="88.576"
                    viewBox="0 0 62.064 88.576"
                  >
                    <path
                      id="Path_110"
                      data-name="Path 110"
                      d="M610-166.717a19.96,19.96,0,0,1-2.682,3.176,19.848,19.848,0,0,1-12.387,5.5q-.7.052-1.417.051t-1.419-.051H573.613a2.263,2.263,0,0,0-2.262,2.264,2.263,2.263,0,0,0,2.262,2.264H617.99a2.124,2.124,0,0,1,2.125,2.123v31.038a2.125,2.125,0,0,1-2.125,2.125H569.041a2.126,2.126,0,0,1-2.125-2.125v-44.331a2.125,2.125,0,0,1,2.125-2.125H571.8c.013.028.03.058.045.086a24.122,24.122,0,0,0,1.963,3.176,24.055,24.055,0,0,0,1.695,2.077,2.269,2.269,0,0,0,3.367-.025,2.273,2.273,0,0,0,.577-1.511,2.263,2.263,0,0,0-.587-1.521,24.575,24.575,0,0,1-1.826-2.2c-.018-.03-.038-.058-.058-.086q-.417-.615-.784-1.263a19.728,19.728,0,0,1-1.455-3.177c-.01-.028-.021-.056-.03-.086a19.933,19.933,0,0,1-1.113-6.882,19.883,19.883,0,0,1,20.035-19.63,19.927,19.927,0,0,1,19.82,19.927,19.866,19.866,0,0,1-1.115,6.585c-.008.03-.02.058-.03.086a19.739,19.739,0,0,1-1.455,3.177q-.367.647-.784,1.263c-.02.028-.038.056-.058.086m7-4.612a24.347,24.347,0,0,0,.895-6.563,24.383,24.383,0,0,0-24.382-24.382,24.383,24.383,0,0,0-24.384,24.382,24.347,24.347,0,0,0,.895,6.563h-5.419a2.124,2.124,0,0,0-2.125,2.125v53.383a2.124,2.124,0,0,0,2.125,2.123h57.814a2.124,2.124,0,0,0,2.125-2.123v-40.089a2.125,2.125,0,0,0-2.125-2.125H607.668a24.47,24.47,0,0,0,5.561-5.5,24.292,24.292,0,0,0,1.963-3.176l.045-.086h2.753a2.124,2.124,0,0,1,2.125,2.125,2.216,2.216,0,0,0,2.216,2.216,2.216,2.216,0,0,0,2.217-2.216V-169.2a2.124,2.124,0,0,0-2.125-2.125Z"
                      transform="translate(-562.484 202.274)"
                    />
                    <path
                      id="Path_111"
                      data-name="Path 111"
                      d="M598.57-186.724a1.4,1.4,0,0,1-.225.744c-.438.688-1.186,1.837-2.113,3.177-.675.972-1.445,2.045-2.264,3.112q-.685.9-1.29,1.629c-3.818,4.637-5.295,4.742-5.31,4.742s-1.491-.106-5.31-4.742q-.605-.734-1.29-1.629c-.82-1.068-1.591-2.14-2.264-3.112-.923-1.329-1.664-2.472-2.105-3.162a1.483,1.483,0,0,1-.235-.8A4.537,4.537,0,0,1,580.7-191.3a4.539,4.539,0,0,1,4.532,4.518,2.156,2.156,0,0,0,2.122,2.153,2.138,2.138,0,0,0,2.155-2.138,4.538,4.538,0,0,1,4.941-4.514,4.572,4.572,0,0,1,4.122,4.519v.038m-4.529-8.853a8.792,8.792,0,0,0-6.672,3.061,8.794,8.794,0,0,0-6.671-3.061,8.82,8.82,0,0,0-8.81,8.81c0,2.9,4.82,8.812,5.506,9.707a42.488,42.488,0,0,0,4.58,5.2c2.067,1.921,3.78,2.818,5.394,2.818s3.327-.9,5.394-2.818a42.627,42.627,0,0,0,4.58-5.2c.686-.895,5.507-6.806,5.507-9.707a8.82,8.82,0,0,0-8.809-8.81"
                      transform="translate(-556.338 206.651)"
                    />
                  </svg>
                </div>
                <div className="box-text">
                  <p className="h4 title">{t("help")}</p>
                  <p>
                    <strong>{t("10 kg = 5 zł")}</strong>
                  </p>
                  <p>{t("for the 4F Foundation")}</p>
                </div>
              </div>
              <div className="grid-item-divider">
                <ArrowRightIcon />
              </div>
              <div className="grid-item">
                <div className="box-image">
                  <svg
                    id="Group_47"
                    data-name="Group 47"
                    xmlns="http://www.w3.org/2000/svg"
                    width="82.331"
                    height="94.636"
                    viewBox="0 0 82.331 94.636"
                  >
                    <path
                      id="Path_114"
                      data-name="Path 114"
                      d="M663.58-169.8a4.348,4.348,0,0,1,.63,2.26,4.364,4.364,0,0,1-4.365,4.365,4.333,4.333,0,0,1-2.26-.63,4.36,4.36,0,0,1-2.1-3.734,4.363,4.363,0,0,1,4.363-4.363,4.362,4.362,0,0,1,3.734,2.1"
                      transform="translate(-609.658 222.902)"
                    />
                    <path
                      id="Path_117"
                      data-name="Path 117"
                      d="M651.542-167.544a4.367,4.367,0,0,1-2.98,4.141,4.387,4.387,0,0,1-1.385.224,4.364,4.364,0,0,1-4.363-4.365,4.334,4.334,0,0,1,.406-1.841,4.362,4.362,0,0,1,3.957-2.522,4.364,4.364,0,0,1,4.365,4.363"
                      transform="translate(-618.811 222.903)"
                    />
                    <path
                      id="Path_116"
                      data-name="Path 116"
                      d="M654.779-174.793v21.821a2.182,2.182,0,0,1-2.182,2.181,2.168,2.168,0,0,1-.62-.09,2.183,2.183,0,0,1-1.562-2.091v-21.821a2.182,2.182,0,0,1,2.183-2.182,2.177,2.177,0,0,1,1.543.639,2.183,2.183,0,0,1,.639,1.543"
                      transform="translate(-613.32 219.241)"
                    />
                    <path
                      id="Path_115"
                      data-name="Path 115"
                      d="M710.7-160.306a1.745,1.745,0,0,1,0,2.468L698.22-145.359a2.182,2.182,0,0,1-3.087,0l-7.695-7.695-13.375-13.377a2.169,2.169,0,0,1-.641-1.543,2.168,2.168,0,0,1,.641-1.542,2.18,2.18,0,0,1,3.085,0l18.789,18.791a1.046,1.046,0,0,0,1.476,0l6.382-6.38.747-.749a1.744,1.744,0,0,0-.017-2.451l-4.918-4.918-17.3-17.3a1.744,1.744,0,0,0-2.468,0l-10.494,10.494L647.57-150.255,636.7-139.386l-1.141,1.14a1.745,1.745,0,0,0,0,2.468l.438.438a15.272,15.272,0,0,1,8.9-2.842,15.3,15.3,0,0,1,10.83,4.468,15.37,15.37,0,0,1,3.242,4.73,15.317,15.317,0,0,1,1.021,3.331,15.333,15.333,0,0,1,.26,2.818,15.406,15.406,0,0,1-.384,3.43,15.284,15.284,0,0,1-2.458,5.474l.372.37a1.745,1.745,0,0,0,2.468,0l28.065-28.065a2.181,2.181,0,0,1,1.543-.639,2.181,2.181,0,0,1,1.543.639,2.185,2.185,0,0,1,0,3.087l-31.152,31.15a1.744,1.744,0,0,1-2.468,0l-4.484-4.484a2.763,2.763,0,0,1-.131-3.76,11.037,11.037,0,0,0,1.07-1.473,10.808,10.808,0,0,0,1.523-4.609q.049-.512.05-1.039a10.861,10.861,0,0,0-1.9-6.153,10.894,10.894,0,0,0-9.012-4.754,10.857,10.857,0,0,0-5.646,1.573,10.948,10.948,0,0,0-1.473,1.07,2.763,2.763,0,0,1-3.76-.131l-4.628-4.63a1.744,1.744,0,0,1,0-2.468l13.518-13.518L679.84-188.7a1.744,1.744,0,0,1,2.468,0l4.561,4.561,6.549,6.549,2.811,2.811,6.466,6.465,1.1-1.1.747-.748a1.746,1.746,0,0,0-.017-2.453L682.31-194.83a1.747,1.747,0,0,0-2.468,0l-1.14,1.14-5.033,5.035-38.106,38.1-2.778,2.778a2.183,2.183,0,0,1-3.085,0,2.183,2.183,0,0,1,0-3.088L679.84-201a1.748,1.748,0,0,1,2.468,0l4.561,4.561,6.549,6.549,2.811,2.811,9.96,9.96,4.51,4.51a1.747,1.747,0,0,1,0,2.47l-4.918,4.918Z"
                      transform="translate(-628.879 201.512)"
                    />
                  </svg>
                </div>
                <div className="box-text">
                  <p className="h4 title">{t("get")}</p>
                  <p>
                    <strong>{t("a discount")}</strong>
                  </p>
                  <p>{t("for 4Fclothes")}</p>
                </div>
              </div>
              <div className="grid-item-divider">
                <ArrowRightIcon />
              </div>
              <div className="grid-item">
                <div className="box-image">
                  <svg
                    id="Group_46"
                    data-name="Group 46"
                    xmlns="http://www.w3.org/2000/svg"
                    width="93.896"
                    height="94.636"
                    viewBox="0 0 93.896 94.636"
                  >
                    <path
                      id="Path_118"
                      data-name="Path 118"
                      d="M791.087-178.213l-3.929,8.427a2.5,2.5,0,0,1-3.323,1.209L774.5-172.93a2.5,2.5,0,0,1-1.209-3.321,2.5,2.5,0,0,1,3.323-1.209l3.176,1.481a40.356,40.356,0,0,0-48.9-18.092,39.95,39.95,0,0,0-24.027,23.926,2.5,2.5,0,0,1-3.076,1.54,2.5,2.5,0,0,1-1.612-3.266,45.7,45.7,0,0,1,9.357-15.224,45.05,45.05,0,0,1,7.989-6.792,45.47,45.47,0,0,1,9.662-4.882,44.973,44.973,0,0,1,17.787-2.685,45.146,45.146,0,0,1,16.846,4.2,45.162,45.162,0,0,1,14.045,10.209,44.887,44.887,0,0,1,7.1,10.128l1.588-3.407a2.5,2.5,0,0,1,3.323-1.209,2.5,2.5,0,0,1,1.209,3.323"
                      transform="translate(-697.426 201.513)"
                    />
                    <path
                      id="Path_119"
                      data-name="Path 119"
                      d="M786.884-165.567A2.5,2.5,0,0,1,788.5-162.3a45.764,45.764,0,0,1-9.358,15.224,45.029,45.029,0,0,1-7.989,6.792,45.432,45.432,0,0,1-9.661,4.883,45.038,45.038,0,0,1-15.467,2.744q-1.157,0-2.318-.059a45.166,45.166,0,0,1-16.85-4.2,45.147,45.147,0,0,1-14.044-10.209,44.872,44.872,0,0,1-7.1-10.128l-1.588,3.407a2.5,2.5,0,0,1-3.323,1.209,2.5,2.5,0,0,1-1.209-3.323l3.929-8.427a2.5,2.5,0,0,1,3.323-1.209l9.334,4.353a2.5,2.5,0,0,1,1.209,3.321,2.5,2.5,0,0,1-3.323,1.209l-3.186-1.485a40.008,40.008,0,0,0,18.093,16.75,40.029,40.029,0,0,0,30.81,1.347,39.957,39.957,0,0,0,24.029-23.926,2.5,2.5,0,0,1,3.076-1.542"
                      transform="translate(-699.354 227.294)"
                    />
                    <path
                      id="Path_120"
                      data-name="Path 120"
                      d="M767.965-169.888l-10.378,9.576a.975.975,0,0,1-1.383-.062l-1.674-1.84-.2,21.28a.977.977,0,0,1-.977.966H736.1a2.5,2.5,0,0,1-2.494-2.494v-.012a2.5,2.5,0,0,1,2.494-2.494h12.3a.975.975,0,0,0,.975-.966l.183-18.875a4,4,0,0,1,6.959-2.653.972.972,0,0,0,.722.319.974.974,0,0,0,.663-.258l2.851-2.63a.976.976,0,0,0,.029-1.407l-9.7-9.7a.973.973,0,0,0-.68-.286l-22.77-.257a.984.984,0,0,0-.7.288l-9.929,9.956a.977.977,0,0,0,.028,1.407l2.963,2.732a.976.976,0,0,0,1.356-.031,4.042,4.042,0,0,1,2.9-1.23,4.117,4.117,0,0,1,4.151,4.122l.029,14.3v7.684a2.5,2.5,0,0,1-2.494,2.494,2.5,2.5,0,0,1-2.494-2.494v-2.3l-.036-17.539-1.9,1.919a.98.98,0,0,1-1.357.031l-10.33-9.531a.976.976,0,0,1-.028-1.407l15.087-15.129a.978.978,0,0,1,.7-.288l26.916.3a.973.973,0,0,1,.679.286L767.994-171.3a.974.974,0,0,1-.029,1.407"
                      transform="translate(-692.025 212.208)"
                    />
                  </svg>
                </div>
                <div className="box-text">
                  <p className="h4 title">{t("give")}</p>
                  <p>{t("a new life to your clothes and")}</p>
                  <p>
                    <strong>{t("close the loop")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <Button
              text={t("Join")}
              as="link"
              href={t("join_link")}
              className="btn-more"
            />
          </div>
        </div>
      </div>
    </StyledHelpPlanet>
  )
}

export default HelpPlanet
